import { render } from "./TaxReportsDue.vue?vue&type=template&id=4b6503a2&scoped=true"
import script from "./TaxReportsDue.vue?vue&type=script&lang=js"
export * from "./TaxReportsDue.vue?vue&type=script&lang=js"

import "./TaxReportsDue.vue?vue&type=style&index=0&id=4b6503a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6503a2"]])

export default __exports__